import BaseInput from '~/components/product/form/BaseInput'
// import isPresent from '~/utils/isPresent'
export default {
  extends: BaseInput,
  props: {
    /** Select options */
    options: {
      type: Array,
      required: true,
    },
    /** Option object key to retrive option name */
    optionTextKey: {
      type: String,
      default: 'name',
    },
    /** Option object key to retrive option value */
    optionValueKey: {
      type: String,
      default: 'value',
    },
    /** If true, select first option automatically */
    autoSelect: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    optionValues() {
      return (this.getOptions() ?? []).map((opt) => this.getOptionValue(opt))
    },
  },
  watch: {
    inputValue(newValue) {
      if (
        this.optionValues.length > 0 &&
        !this.optionValues.includes(newValue)
      ) {
        this.resetInputValue()
      }
    },
    options(newOptions) {
      if (
        newOptions?.length === 0 ||
        !this.optionValues.includes(this.inputValue)
      )
        this.inputValue = ''
    },
  },
  methods: {
    getOptionText(option) {
      if (option instanceof Object) return option?.[this.optionTextKey]

      return option ?? ''
    },
    getOptionValue(option) {
      if (this.optionValueKey === '@self') return option
      if (option instanceof Object) return option?.[this.optionValueKey]

      return option ?? ''
    },
    selectOption(option) {
      this.inputValue = this.getOptionValue(option)
    },
    selectGroupOption(option) {
      // eslint-disable-next-line camelcase
      if (option?.price || option?.old_price) {
        this.$store.dispatch('product/setCurrentPrice', option?.price)
        // eslint-disable-next-line camelcase
        this.$store.dispatch('product/setOldPrice', option?.old_price)
      }
      this.selectOption(option)
    },
    resetInputValue() {
      if (this.autoSelect) this.selectDefaultOption()
      else this.inputValue = ''
    },
    /** Returns ordered options or the default one */
    getOptions() {
      return this.orderedOptions || this.options
    },
    selectDefaultOption() {
      this.selectOption(this.getOptions()?.[0])
    },
  },
  created() {
    if (this.autoSelect && !this.value) {
      this.selectDefaultOption()
    }
  },
  beforeDestroy() {
    // Tell the parent componet that I died
    this.$emit('input', null)
  },
}
